"use strict";
/**
 * Utils module.
 * @module array
 * @see https://gitlab.cdfsunrise.com/frontend/core/-/tree/main/packages/utils
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueByKey = void 0;
/**
 * 对象数组去重
 * examples
 * ``` js
 * [1,2,2,3,3,4]
 * =>
 * [1,2,3,4]
 *
 * ([{id:1,name:'foo1'},{id:1,name:'foo2'},{id:2,name:'bar'}],'id')
 * =>
 * [{id:1,name:'foo1'},{id:2,name:'bar'}]
 * ```
 * @param arr T[]
 * @param key string
 * @returns T[]
 */
var uniqueByKey = function (arr, key) {
    var e_1, _a;
    if (!arr) {
        return arr;
    }
    if (key === undefined) {
        return __spreadArray([], __read(new Set(arr)), false);
    }
    var map = new Map();
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var item = arr_1_1.value;
            if (!map.has(item[key])) {
                map.set(item[key], item);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return __spreadArray([], __read(map.values()), false);
};
exports.uniqueByKey = uniqueByKey;
//# sourceMappingURL=index.js.map